import React, { useState, useEffect } from 'react';
import ApiService from '../../../../services/apiService';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';

const PaymentSaleReport = () => {
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState();
  const { t } = useTranslation();

  const [branches, setBranches] = useState([]);
  const [selectedBranch, setSelectedBranch] = useState(null);

  const getFormattedDate = (date) => new Date(date).toISOString().slice(0, 16);

  const today = new Date();
  const tenDaysAgo = new Date();
  tenDaysAgo.setDate(today.getDate() - 10);

  const [formData, setFormData] = useState({
    fromDate: getFormattedDate(tenDaysAgo),
    toDate: getFormattedDate(today),
  });

  const clean = (v) => (v && typeof v === 'object' ? '0' : v || '0');

  // -----------------------------------------
  // ⭐ Fetch Branches
  // -----------------------------------------
  const fetchBranches = async () => {
    try {
      const apiService = new ApiService();
      const res = await apiService.get('GET_BRANCH');
      const list = res?.data?.result || [];

      const mapped = list.map((b) => ({
        value: b.id,
        label: b.branchName,
      }));

      setBranches(mapped);
    } catch (error) {
      console.error('Error fetching branches:', error);
    }
  };

  useEffect(() => {
    fetchBranches();
  }, []);

  // -----------------------------------------
  // ⭐ Fetch Payment Sale Report (Updated)
  // -----------------------------------------
  const getReportData = async () => {
    try {
      const apiService = new ApiService();
      const params = new URLSearchParams();

      params.append('ReportType', 'Payment Method');
      params.append('Measure', 'Revenue');
      params.append('StartDate', formData.fromDate);
      params.append('EndDate', formData.toDate);
      params.append('Comparison', 'No Comparison');

      // ⭐ FIX: Always send BranchId (0 = all branches)
      params.append('BranchId', selectedBranch?.value || 0);

      const res = await apiService.getApiParamater('GET_SALE_SUMMERY', `?${params.toString()}`);

      setData(res?.data?.result || []);
      setPagination(res.data.paginationData);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const calculateRevenue = (item) => {
    const cogs = typeof item.CostOfGoodsSold === 'number' ? item.CostOfGoodsSold : 0;
    const gp = typeof item.GrossProfit === 'number' ? item.GrossProfit : 0;
    return (cogs + gp).toFixed(2);
  };

  return (
    <div className="p-5">
      <div className="row">
        {/* ⭐ Branch Dropdown */}
        <div className="col-3">
          <label className="form-label">Select Branch</label>
          <Select
            value={selectedBranch}
            onChange={(opt) => setSelectedBranch(opt)}
            options={branches}
            placeholder="Select Branch"
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 999999 }),
              menu: (base) => ({ ...base, zIndex: 999999 }),
            }}
            isClearable
          />
        </div>

        <div className="col-3">
          <label className="form-label">
            {t('from')} {t('date')}
          </label>
          <input type="date" className="form-control" value={formData.fromDate} onChange={handleInputChange} name="fromDate" />
        </div>

        <div className="col-3">
          <label className="form-label">
            {t('to')} {t('date')}
          </label>
          <input type="date" className="form-control" value={formData.toDate} onChange={handleInputChange} name="toDate" />
        </div>

        <div className="col-3 mt-3">
          <button className="mt-3 addItem-btn" onClick={getReportData}>
            {t('search')}
          </button>
        </div>
      </div>

      {/* Table */}
      <div className="POsgridshad rounded p-4 mt-5">
        <div className="custom-table-container">
          <table className="custom-table">
            <thead>
              <tr>
                <th>
                  {t('payment')} {t('type')}
                </th>
                <th>
                  {t('transaction')} {t('count')}
                </th>
                <th>
                  {t('transaction')} {t('amount')}
                </th>
                <th>{t('tax')}</th>
                <th>
                  {t('total')} {t('amount')}
                </th>
              </tr>
            </thead>

            <tbody>
              {data?.map((item, idx) => (
                <tr key={idx}>
                  <td>{clean(item.TypeName)}</td>
                  <td>{clean(item.Transactions)}</td>
                  <td>{clean(item.TransactionAmount)}</td>
                  <td>{clean(item.Tax)}</td>
                  <td>{calculateRevenue(item)}</td>
                </tr>
              ))}
            </tbody>

            <tfoot>
              <tr className="bg-green-100 font-bold">
                <td colSpan={4} className="text-end">
                  Overall Total Revenue
                </td>
                <td>{data.reduce((acc, curr) => acc + Number(calculateRevenue(curr)), 0).toFixed(2)}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  );
};

export default PaymentSaleReport;
